module.exports = __webpack_public_path__ + "img/2017_S.6eba45a0.png";